import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {AirBookingCreateRoute, AirBookingEditRoute} from "../../../routesConstants";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import {Link} from "react-router-dom";
import DataTable from "../../../../components/dataTable";
import AmadeusButton from "../components/amadeusButton";
import ListQueryForm from "../components/ListQueryForm";
import {Helmet} from "react-helmet";
import {Form} from "react-bootstrap";
import numberFormat from "../../../../helpers/numberFormat";

const AirlineList = (props)=>{
  const memoryQuery =  JSON.parse(localStorage.getItem("airQuery")) || {}
  const memoryPage = memoryQuery ? +memoryQuery.page : 0
  const [query, setQuery] = useState(memoryQuery);
  const [showToPaiments, setShowToPaimets] = useState(false)


  useEffect(() => {
    if(localStorage.getItem("airQuery")){
      setQuery(memoryQuery)
      localStorage.removeItem("airQuery")
    }
  }, []);
  const columns = [
    {
      Header: 'Код бронирования',
      accessor: 'bookingNumber',
      Cell: ({value, row}) => <Link to={AirBookingEditRoute + row.original._id } onClick={()=>{
        localStorage.setItem("airQuery",  JSON.stringify({...query, page:localStorage.getItem("page")}))
      }}>
        {value}
      </Link>
    },
    {
      Header: 'Пассажиры',
      accessor: 'paxes',
      Cell: ({value, row}) => <span>{value.map((pax,index)=><span key={index}>{pax.lastName} {pax.firstName}<br/></span>)}</span>
    },
    {
      Header: 'Маршрут',
      accessor: 'route',
    },
    {
      Header: 'Дата выписки',
      accessor: 'issueDate',
      Cell: ({value, row}) => <span>{value}</span>
    },
    {
      Header: 'Дата создания',
      accessor: 'createdAt',
      Cell: ({value, row}) => <span>{value}</span>
    },
    {
      Header: "Опл/Вык",
      accessor: "paid",
      Cell: ({ value, row }) => {
        const foundCash = row.original.foundInCash.found
        const totalServ = row.original.foundInCash.total
        return (
          <div className={'d-flex justify-content-center gap-2'}>
            {!row.original.issuedWithoutDocs ?
              <i className="fa fa-file-text " style={{color: 'rgba(107,112,161,0.8)'}}></i> : value ? (
                <i className={"fa fa-check-circle text-success"}/>
              ) : (
                <i className={"fa fa-times-circle text-danger"}/>
              )}

            {row.original.issuedWithoutDocs &&
              <>
                /
                <i
                  className={`fa fa-circle text-${foundCash === totalServ ? 'success' : foundCash === 0 ? 'danger' : 'warning'}`}/>
              </>
            }
          </div>
        )
      }
    },
  ]

  const columsForPaiment = [
    {
      Header: 'Дата выписки',
      accessor: 'issueDate',
      Cell: ({value, row}) => <Link to={AirBookingEditRoute + row.original._id } target={'_blank'}>
        {value}
      </Link>
    },
    {
      Header: ()=>'Билеты',
      accessor: 'zakup',
      Cell: ({value, row}) => <>{value.map((t,i)=>{
        console.log('row',row)
        return <div key={i}>
          {t.ticket}
        </div>
      })}</>
    },
    {
      Header: ()=>'Закуп',
      accessor: 'createdAt',
      Cell: ({value, row}) => <>{row.original.zakup.map((t,i)=>{
        return <div key={i}>
          {numberFormat(t.summ)}
        </div>
      })}</>
    },

    columns[1],
    columns[2],
    {
      Header: 'Покупатель',
      accessor: 'buyer',
    },
    columns[5],
  ]

  return <>
    <Helmet>
      <title>БСО</title>
    </Helmet>
        <div>
          <Portlet>
            <PortletHeader
              title={<>
                <AmadeusButton/>
              </>
              }
              toolbar={
                <PortletHeaderToolbar>
                  <div className={'d-flex gap-2 align-items-center'}>
                    <ListQueryForm query={query} setQuery={setQuery}/>
                    <Link to={AirBookingCreateRoute} className="btn btn-sm btn-primary">
                      <i className="la la-plus"/>
                      Добавить
                    </Link>
                  </div>


                </PortletHeaderToolbar>
              }
            />
              <Form.Label className={'d-flex justify-content-end align-items-center gap-2 m-2'}>
                Для оплат
                <input
                  defaultChecked={showToPaiments}
                  checked={showToPaiments}
                  onChange={(e) => {
                    setShowToPaimets(!showToPaiments)
                  }}
                  type={"checkbox"}
                />{" "}

              </Form.Label>
            <PortletBody className={'pt-0'}>

              <DataTable columns={showToPaiments? columsForPaiment :columns} itemsPerPage={20} search={query} url={`/api/air/airBooking`} startPage={memoryPage}/>
            </PortletBody>
          </Portlet>
        </div>
  </>
}


export default connect(null)(AirlineList)
